export default "__VITE_ASSET__DofLWyP0__";